<script setup>
import {computed, ref, watch, onMounted, nextTick} from 'vue'

import FormGroup from "@/common/form/FormGroup.vue"
import PageEditorContentSettings from "./PageEditorContentSettings.vue"

import {usePageEditorStore} from '@/stores/pageEditor'
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String
})

const pageEditorStore = usePageEditorStore()
const formStore = useFormStore(props.formId)

const form = ref(null)

const savePromise = ref(undefined)
const savePromise2 = ref(undefined)

const pageContentId = computed(() => pageEditorStore.activePageContentId)
const activeTab = computed(() => pageEditorStore.contentPanelActiveTab)
const fields = computed(() => formStore.fields || [])
const modifiedData = computed(() => formStore.modifiedData)

const save = async () => {
    await formStore.save()
    await pageEditorStore.reloadContent(pageContentId.value)
}

watch(modifiedData, (newValue) => {
    if (!newValue) {
        return
    }

    if (savePromise.value) {
        clearTimeout(savePromise.value)
        savePromise.value = undefined
    }

    const columnName = Object.keys(newValue)[0]
    const type = fields.value.find(o => o.columnName === columnName)?.type

    // Only apply the delay to text input fields.
    const delay = ['texteditor', 'text'].indexOf(type) > -1 ? 500 : 0

    if (delay) {
        // This timeout is cleared as the user types, saving after they pause.
        savePromise.value = setTimeout(() => {
            save()
        }, delay)

        // This timeout runs periodically during continuous typing to update the UI framework preview.
        if (!savePromise2.value) {
            savePromise2.value = setTimeout(() => {
                savePromise2.value = undefined
                save()
            }, 1000)
        }
    } else {
        save()
    }
})

onMounted(() => {
    nextTick(() => {
        formStore.setFormEl(form.value)
    })
})
</script>

<template>
    <form ref="form">
        <FormGroup class="mb-3" v-for="(field, i) in fields" :key="i" :form-id="formId" :field="field"
                   :hide-help-text="true"/>

        <PageEditorContentSettings v-if="activeTab === 'Settings'" :form-id="formId"/>
    </form>
</template>